import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { shopifyService } from '../../services/shopify';
import '../../styles/Catalogue.css';
import TopMenu from '../../contexts/TopMenu';

function Catalogue({ email, onLogout }) {
  const navigate = useNavigate();
  const { handle } = useParams();
  const [collection, setCollection] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchCollection = async () => {
      try {
        const response = await shopifyService.getCollectionDetails(handle);
        setCollection(response.data?.collection);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCollection();
  }, [handle]);

  const handleProductClick = (product) => {
    navigate(`/product/${product.handle}`, { state: { product } });
  };

  if (loading) {
    return (
      <div className="catalogue-loading">
        <div className="loader"></div>
        <p>Loading catalogue...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="catalogue-error">
        <p>{error}</p>
        <button onClick={() => navigate(`/${handle}`)}>Back to Collection</button>
      </div>
    );
  }

  return (
    <div className="dashboard-root">
      <TopMenu pageTitle="Product Catalogue" email={email} onLogout={onLogout} />
      <div className="dashboard-container">
        <div className="catalogue">
          <div className="products-grid">
            {collection?.products?.map(product => (
              <div 
                key={product.id} 
                className="product-card"
                onClick={() => handleProductClick(product)}
                style={{ cursor: 'pointer' }}
              >
                <div className="product-image">
                  <img 
                    src={product.images?.[0]?.url || '/placeholder-product.png'} 
                    alt={product.title}
                    onError={(e) => {
                      e.target.src = '/placeholder-product.png';
                    }}
                  />
                </div>
                <div className="product-info">
                  <h3 style={{ 
                    textTransform: 'uppercase', 
                    fontSize: '12px',
                    fontWeight: 'normal',
                    // marginBottom: '5px',
                    color: '#333',
                    // textAlign: 'center',
                    lineHeight: '1.2',
                  }}>{product.title}</h3>
                  <p className="product-price">
                    ₹{product.variants?.[0]?.price}
                    {product.variants?.[0]?.compare_at_price && (
                      <span className="compare-price">₹{product.variants?.[0]?.compare_at_price}</span>
                    )}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {(!collection?.products || collection.products.length === 0) && (
            <div className="no-products">
              <h3>No Products Found</h3>
              <p>This collection doesn't have any products yet.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Catalogue; 